// Material Dashboard 3 PRO React
import { useState } from "react";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";

import Header from "./customstyle/header";
import Navbar from "./navbar";

import LinePlot from "components/Charts/LinePlotComponent";
import BarChart from "components/Charts/BarChartComponent";

import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import StateCheckboxes from "components/StateSelect";

function Charts() {
  const [selectedState, setSelectedState] = useState(null);
  const [selectedStateName, setSelectedStateName] = useState(null);

  return (
    <DashboardLayout>
        <Navbar setSelectedState={setSelectedState} setSelectedStateName={setSelectedStateName}/>
        <MDBox mb={2} />
        <Header>
            <MDBox pt={2} px={2} lineHeight={1.25}>
              <div style={{display:'flex'}}>
                <Card>
                </Card>
                <MDBox mb={1}>
                  <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'flex-start', gap: '24px' }}>
                    <Card style={{ maxHeight: '500px', overflowY: 'auto', width: '250px' }}>
                      <MDBox pt={2} px={2} lineHeight={1.25}>
                        <MDTypography variant="h5" fontWeight="medium">
                          <StateCheckboxes setSelectedState={setSelectedState} setSelectedStateName={setSelectedStateName} />
                        </MDTypography>
                      </MDBox>
                    </Card>
                    <div style={{ flexGrow: 1 }}>
                      <LinePlot selectedState={selectedState} selectedStateName={selectedStateName} />
                    </div>
                  </div>
                </MDBox>
              </div>
            </MDBox>
        </Header>
        <Footer />
    </DashboardLayout>
  );
}

export default Charts;
